import Vue from 'vue'

// 注册全局组件
Vue.component('SearchForm', () => import('./common/SearchForm.vue'))
Vue.component('toolBarBtn', () => import('./common/toolBarBtn.vue'))
Vue.component('navList', () => import('./common/navList.vue'))
Vue.component('errorTooltip', () => import('./common/errorTooltip.vue'))
Vue.component('AttachmentDrawer', () => import('./common/AttachmentDrawer.vue'))
Vue.component('YKDivider', () => import('./common/YKDivider.vue')) // 分割符
Vue.component('BatchInput', () => import('./common/BatchInput.vue')) // 批量输入
Vue.component('PreviewImage', () => import('./Modal/Image/PreviewImage.vue')) // 图片预览

// 首页
Vue.component('NavMenu', () => import('./home/NavMenu.vue'))
Vue.component('HomeHeader', () => import('./home/HomeHeader.vue'))

// 基础设置
Vue.component('productVersion', () =>
  import('./baseSettings/productVersion.vue')
)
Vue.component('menuModifyDaySetting', () =>
  import('./baseSettings/menuModifyDaySetting.vue')
)

// 选择框
Vue.component('EmployeeSelect', () =>
  import('./Modal/Employee/EmployeeSelect.vue')
)
Vue.component('PickPosition', () => import('./Modal/Position/PickPosition.vue'))
Vue.component('DateInput', () => import('./Modal/Date/DateInput.vue'))
